// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageCarousel_carouselContainer__Iyn3u {
  background-color: var(--color-background);
  min-height: min(30.5rem, 66vh);
  padding: calc(var(--space-xxl) + var(--space-md)) 0 var(--space-sm);
}

.ImageCarousel_heroLayout__vbRgh {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 34.5rem;
  overflow-x: clip;
}

.ImageCarousel_title__GyIMB {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.08em;
  font-size: clamp(2rem, 3.4vw, 2.85rem);
  font-weight: var(--font-weight-bold);
  line-height: 1.04;
  margin-bottom: var(--space-sm);
}

.ImageCarousel_titleLine__SeQwT {
  display: block;
  opacity: 0;
  transform: translateY(0.7rem);
  animation: ImageCarousel_titleLineReveal__gZKYT 0.7s ease forwards;
}

.ImageCarousel_titleAccent__895KS {
  color: #4da3ff;
}

.ImageCarousel_overlay__sDUrB {
  position: relative;
  z-index: 3;
  text-align: left;
  color: var(--color-text);
  max-width: min(42rem, 100%);
  padding: 0;
}

.ImageCarousel_content__Dzc9C {
  font-size: var(--font-size-base);
  margin-bottom: var(--space-md);
}

.ImageCarousel_visualWrap__lxh\\+j {
  position: absolute;
  inset: -2rem -6vw -1rem 0;
  z-index: 1;
  overflow: visible;
}

.ImageCarousel_actions__SYfm4 {
  display: flex;
  align-items: center;
  gap: var(--space-md);
}

.ImageCarousel_button__o0Eyr {
  background-color: var(--color-text);
  color: var(--color-background);
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-small);
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.ImageCarousel_button__o0Eyr:hover {
  background-color: var(--color-text-subtle);
  color: var(--color-background);
}

.ImageCarousel_secondaryAction__U82c\\+ {
  flex: 0 0 auto;
}

@keyframes ImageCarousel_titleLineReveal__gZKYT {
  from {
    opacity: 0;
    transform: translateY(0.7rem);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .ImageCarousel_carouselContainer__Iyn3u {
    min-height: auto;
    padding: var(--space-xl) 0;
  }

  .ImageCarousel_heroLayout__vbRgh {
    display: block;
    min-height: auto;
  }

  .ImageCarousel_overlay__sDUrB {
    max-width: 100%;
    padding: 0 var(--space-lg);
  }

  .ImageCarousel_visualWrap__lxh\\+j {
    position: relative;
    inset: auto;
    margin-top: var(--space-md);
    padding: 0 var(--space-lg);
    overflow: visible;
  }

  .ImageCarousel_title__GyIMB {
    font-size: var(--font-size-large);
  }

  .ImageCarousel_content__Dzc9C {
    font-size: var(--font-size-medium);
    margin-bottom: var(--space-lg);
  }

  .ImageCarousel_actions__SYfm4 {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .ImageCarousel_carouselContainer__Iyn3u {
    margin-top: var(--space-lg);
    padding: var(--space-lg) 0;
  }

  .ImageCarousel_overlay__sDUrB {
    padding: 0 var(--space-md);
  }

  .ImageCarousel_visualWrap__lxh\\+j {
    padding: 0 var(--space-md);
  }

  .ImageCarousel_title__GyIMB {
    font-size: var(--font-size-xlarge);
    margin-bottom: var(--space-lg);
  }

  .ImageCarousel_content__Dzc9C {
    font-size: var(--font-size-medium);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,kEAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,kCAAkC;EACpC;AACF","sourcesContent":[".carouselContainer {\n  background-color: var(--color-background);\n  min-height: min(30.5rem, 66vh);\n  padding: calc(var(--space-xxl) + var(--space-md)) 0 var(--space-sm);\n}\n\n.heroLayout {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 34.5rem;\n  overflow-x: clip;\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.08em;\n  font-size: clamp(2rem, 3.4vw, 2.85rem);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.04;\n  margin-bottom: var(--space-sm);\n}\n\n.titleLine {\n  display: block;\n  opacity: 0;\n  transform: translateY(0.7rem);\n  animation: titleLineReveal 0.7s ease forwards;\n}\n\n.titleAccent {\n  color: #4da3ff;\n}\n\n.overlay {\n  position: relative;\n  z-index: 3;\n  text-align: left;\n  color: var(--color-text);\n  max-width: min(42rem, 100%);\n  padding: 0;\n}\n\n.content {\n  font-size: var(--font-size-base);\n  margin-bottom: var(--space-md);\n}\n\n.visualWrap {\n  position: absolute;\n  inset: -2rem -6vw -1rem 0;\n  z-index: 1;\n  overflow: visible;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n}\n\n.button {\n  background-color: var(--color-text);\n  color: var(--color-background);\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-small);\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.button:hover {\n  background-color: var(--color-text-subtle);\n  color: var(--color-background);\n}\n\n.secondaryAction {\n  flex: 0 0 auto;\n}\n\n@keyframes titleLineReveal {\n  from {\n    opacity: 0;\n    transform: translateY(0.7rem);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .carouselContainer {\n    min-height: auto;\n    padding: var(--space-xl) 0;\n  }\n\n  .heroLayout {\n    display: block;\n    min-height: auto;\n  }\n\n  .overlay {\n    max-width: 100%;\n    padding: 0 var(--space-lg);\n  }\n\n  .visualWrap {\n    position: relative;\n    inset: auto;\n    margin-top: var(--space-md);\n    padding: 0 var(--space-lg);\n    overflow: visible;\n  }\n\n  .title {\n    font-size: var(--font-size-large);\n  }\n\n  .content {\n    font-size: var(--font-size-medium);\n    margin-bottom: var(--space-lg);\n  }\n\n  .actions {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .carouselContainer {\n    margin-top: var(--space-lg);\n    padding: var(--space-lg) 0;\n  }\n\n  .overlay {\n    padding: 0 var(--space-md);\n  }\n\n  .visualWrap {\n    padding: 0 var(--space-md);\n  }\n\n  .title {\n    font-size: var(--font-size-xlarge);\n    margin-bottom: var(--space-lg);\n  }\n\n  .content {\n    font-size: var(--font-size-medium);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `ImageCarousel_carouselContainer__Iyn3u`,
	"heroLayout": `ImageCarousel_heroLayout__vbRgh`,
	"title": `ImageCarousel_title__GyIMB`,
	"titleLine": `ImageCarousel_titleLine__SeQwT`,
	"titleLineReveal": `ImageCarousel_titleLineReveal__gZKYT`,
	"titleAccent": `ImageCarousel_titleAccent__895KS`,
	"overlay": `ImageCarousel_overlay__sDUrB`,
	"content": `ImageCarousel_content__Dzc9C`,
	"visualWrap": `ImageCarousel_visualWrap__lxh+j`,
	"actions": `ImageCarousel_actions__SYfm4`,
	"button": `ImageCarousel_button__o0Eyr`,
	"secondaryAction": `ImageCarousel_secondaryAction__U82c+`
};
export default ___CSS_LOADER_EXPORT___;
